import { render, staticRenderFns } from "./cardType.vue?vue&type=template&id=0bbfeb8e&scoped=true"
import script from "./cardType.vue?vue&type=script&lang=js"
export * from "./cardType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbfeb8e",
  null
  
)

export default component.exports